var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaginationNextPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7266 7.14844L8.58594 1.29688C8.14844 0.895833 7.71094 0.895833 7.27344 1.29688C6.8724 1.69792 6.89062 2.11719 7.32812 2.55469L11.9766 7.80469L7.32812 13C7.14583 13.1823 7.05469 13.401 7.05469 13.6562C7.05469 13.875 7.14583 14.0755 7.32812 14.2578C7.72917 14.6953 8.14844 14.6953 8.58594 14.2578L13.7266 8.40625C13.9089 8.22396 14 8.02344 14 7.80469C14 7.54948 13.9089 7.33073 13.7266 7.14844ZM1.03906 13C0.638021 13.4375 0.638021 13.875 1.03906 14.3125C1.4401 14.7135 1.85938 14.6953 2.29688 14.2578L7.49219 8.40625C7.63802 8.22396 7.71094 8.02344 7.71094 7.80469C7.71094 7.54948 7.63802 7.33073 7.49219 7.14844L2.29688 1.29688C2.11458 1.11458 1.89583 1.02344 1.64062 1.02344C1.42188 1.02344 1.22135 1.11458 1.03906 1.29688C0.638021 1.69792 0.638021 2.11719 1.03906 2.55469L5.6875 7.80469L1.03906 13Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationNextPage);
export default __webpack_public_path__ + "static/media/pagination-next-page.203eb9da41cac8b48bb8fa7d06572a4b.svg";
export { ForwardRef as ReactComponent };